/*
These are the reducers for the page.
Think of these as the "event handlers" for the page.
They process business logic and update the state within the page's store
*/

import { createReducer } from '@common/redux-utils';
import {
  UsersActionType,
  UsersSearchInitAction,
  UsersSearchFailureAction,
  UsersSearchSuccessAction
} from './users.actions';
// import { EscrowOfficeViewModel } from '../_services/EscrowOfficeService';
import { ProfileViewModel } from '@models/Auth';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface UsersState {
  readonly message: string;
  readonly query: string | null;
  readonly usersLoading: boolean;
  readonly usersPageCount: number;
  readonly usersPageNumber: number;
  readonly usersPageSize: number;
  readonly users: ProfileViewModel[];
  readonly orderBy?: string;
  readonly orderDirection?: string;
  readonly roles?: string[];
}

// This is the initial state of the page
const initialState: UsersState = {
  message: 'Initial state',
  query: null,
  usersLoading: false,
  usersPageCount: 0,
  usersPageNumber: 1,
  users: [],
  usersPageSize: 10
};
/*
export interface UsersComponentProperties {
    readonly getUsers: (pageNumber: number, pageSize: number, query: string | null) => void;
}
*/

/********** Search **********/
function handleUsersSearchInit(state: UsersState, action: UsersSearchInitAction): UsersState {
  return {
    ...state,
    message: 'Search Init!',
    query: action.query,
    usersLoading: true
  };
}
function handleUsersSearchFailure(state: UsersState, action: UsersSearchFailureAction): UsersState {
  return {
    ...state,
    message: action.errorMessage,
    usersLoading: false
  };
}
function handleUsersSearchSuccess(state: UsersState, action: UsersSearchSuccessAction): UsersState {
  return {
    ...state,
    message: 'Search Success!',
    usersLoading: false,
    usersPageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    usersPageNumber: action.pageNumber,
    usersPageSize: action.pageSize,
    users: action.result.results
  };
}

/********** Save **********/
/*
function handleEscrowOfficeSaveInit(state: EscrowOfficeState, action: EscrowOfficeSaveInitAction): EscrowOfficeState {
    return state;
}
function handleEscrowOfficeSaveSuccess(state: EscrowOfficeState, action: EscrowOfficeSaveSuccessAction): EscrowOfficeState {
    if (!action.currentId) {
        return state;
    }
    return {
        ...state,
        message: 'SUCCESS - escrow office saved - ' + action.currentId,
        officeId: action.currentId
    };
}
function handleEscrowOfficeSaveFailure(state: EscrowOfficeState, action: EscrowOfficeSaveFailureAction): EscrowOfficeState {
    if (!action.errorMessage) {
        return state;
    }
    return {
        ...state,
        message: 'ERROR - save escrow office failed - ' + action.errorMessage
    };
}
*/

/********** Get **********/
/*
function handleEscrowOfficeGetInit(state: EscrowOfficeState, action: EscrowOfficeGetInitAction): EscrowOfficeState {
    return state;
}
function handleEscrowOfficeGetSuccess(state: EscrowOfficeState, action: EscrowOfficeGetSuccessAction): EscrowOfficeState {
    if (!action.currentId) {
        return state;
    }
    return {
        ...state,
        message: 'SUCCESS - get escrow office done - ' + action.currentId,
        officeId: action.currentId
    };
}
function handleEscrowOfficeGetFailure(state: EscrowOfficeState, action: EscrowOfficeGetFailureAction): EscrowOfficeState {
    if (!action.errorMessage) {
        return state;
    }
    return {
        ...state,
        message: 'ERROR - get escrow office failed - ' + action.errorMessage
    };
}
*/

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const UsersReducer = createReducer(initialState, {
  /********** Search **********/
  [UsersActionType.SearchInit]: handleUsersSearchInit,
  [UsersActionType.SearchFailure]: handleUsersSearchFailure,
  [UsersActionType.SearchSuccess]: handleUsersSearchSuccess
});



// WEBPACK FOOTER //
// ./src/users/users.reducer.ts